import React, { useState } from "react";
import infoCircle from "../../assets/mobile/info-icon-black.svg";

const Recommendations = ({ heading, list }) => {
  console.log("list: ", list);
  const [showAll, setShowAll] = useState(false);
  
  
  const displayedList = showAll ? list : list?.slice(0, 3);
  const hasMore = list && list.length > 3;

  return (
    <div className="w-full lg:w-1/2 bg-[#F4F4F4] rounded-lg p-4 lg:p-6">
      <div className="flex items-center gap-2 lg:gap-3 pb-3 lg:pb-4 border-b border-gray-300">
        <p className="text-sm lg:text-base font-semibold text-[#454545]">
          {heading}
        </p>
        <img src={infoCircle} className="w-3 h-3 lg:w-4 lg:h-4" alt="info" />
      </div>
      <div className="mt-4">
        <ul className={`space-y-2 lg:space-y-3 text-xs lg:text-sm text-[#454545] ${heading === "Important information" ? "list-none" : "list-disc list-inside"}`}>
          {displayedList?.map((item) => (
            <li key={item.id} className="leading-relaxed whitespace-pre-line">
              {item.text}
            </li>
          ))}
        </ul>
        
        {hasMore && (
          <button
            onClick={() => setShowAll(!showAll)}
            className="mt-4 text-xs lg:text-sm font-semibold text-[#1569AB] hover:text-[#104d7a] transition-colors flex items-center gap-1"
          >
            {showAll ? (
              <>
                View Less
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                </svg>
              </>
            ) : (
              <>
                View More ({list.length - 3} more)
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </>
            )}
          </button>
        )}
      </div>
    </div>
  );
};

export default Recommendations;
